import Form, { Field } from 'rc-field-form';
import {
  itemWrapperErrorDisplayAdaptor,
  antdErrorDisplayAdaptor,
} from './tools';
import FormItem from '@/src/components/Antd/FormItem/FormItem';
import React from 'react';
import { EnumFormItemStatus } from 'src/types/common/validation';

const WrappedItemGenerator = (Comp, fieldData) => {
  const { props, meta } = fieldData;
  const WrapperComp = (_props) => {
    const formItemProps = antdErrorDisplayAdaptor(meta);
    return (
      <FormItem {...formItemProps}>
        <Comp {..._props} {...props} {...meta} />
      </FormItem>
    );
  };
  return WrapperComp;
};

const FieldFormItem = (props) => {
  const { error, help, children } = props;
  return (
    <FormItem
      {...(error && {
        status: EnumFormItemStatus.error,
        help: help,
      })}>
      {children}
    </FormItem>
  );
};

export {
  Form,
  Field,
  WrappedItemGenerator,
  antdErrorDisplayAdaptor,
  itemWrapperErrorDisplayAdaptor,
  FieldFormItem,
};
